import script from "./auction-content.vue?vue&type=script&setup=true&lang=js"
export * from "./auction-content.vue?vue&type=script&setup=true&lang=js"

import "./auction-content.vue?vue&type=style&index=0&id=773ecc18&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773ecc18"]])

export default __exports__